<template>
  <div class="field has-addons">
    <div class="control">
      <button class="button is-static">{{ label }}</button>
    </div>
    <div class="control has-icons-left ">
      <input
        v-model.number="dice.action"
        required
        class="input"
        type="number"
        max="10"
        min="1"
        step="1"
      />
      <span class="icon has-text-dark is-left"><i class="fas fa-dice-d6"></i></span>
    </div>
    <div class="control has-icons-left ">
      <input
        v-model.number="dice.power"
        required
        class="input"
        type="number"
        max="10"
        min="0"
        step="1"
      />
      <span class="icon  has-text-danger is-left"><i class="fas fa-dice-d6"></i></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiceFormField",
  props: {
    dice: {
      type: Object,
      required: true
    },
    label: { type: String, required: true }
  }
};
</script>
